<template lang="pug">
footer
	.container.py-3
		.row.align-items-center.justify-content-md-between
			.col-md-3.text-center
				img.mx-auto(src='../assets/img/brand/logo-blanco-puro.png', alt='Logo de Plastomex')
			.col-md-9
				ul.nav.nav-footer.py-2.justify-content-md-end.text-center.d-block.d-md-flex
					li.nav-item.px-3
						router-link(to='./nosotros') Nosotros
					li.nav-item.px-3
						router-link(to='./galeria') Galería
					li.nav-item.px-3
						router-link(to='./productos') Productos
					li.nav-item.px-3
						router-link(to='./contacto') Contacto
					li.nav-item.px-3
						router-link(to='./bolsa') Bolsa de Trabajo
					// <li class="nav-item p-3"><a href="./#.html">Cotiza</a></li>
	.copyright
		.container.px-4.px-md-0
			.d-flex.flex-wrap
				.mx-auto.mx-md-0.p-2.order-2.order-md-1.align-self-center
					| © Plastomex {{year}}.
				.mx-auto.p-2.order-3.order-md-1.align-self-center
					| Hecho con ♡ por 
					a(href='http://clout.com.mx', target='_blanc')
						strong CLOUT
				//.mx-auto.ml-md-auto.mr-md-0.p-2.order-1.navbar-dark.navbar-expand
					a(href='https://www.facebook.com/plastomex')
						i.fab.fa-facebook.fa-lg
						br
</template>
<script>
export default {
  name: 'app-footer',
  data() {
	return {
	  year: new Date().getFullYear()
	}
  }
};
</script>
<style>
</style>
